import toLower from 'lodash/toLower';
export class EnvUtil {
    static get isApp() {
        try {
            return !!(window && window.location);
        }
        catch (e) {
            return false;
        }
    }
    static get isNode() {
        try {
            return !!(process && process.env);
        }
        catch (e) {
            return false;
        }
    }
    static getAppEnv() {
        if (EnvUtil.isApp) {
            let domain = window.location.hostname;
            if (domain) {
                domain = domain.toLowerCase();
                if (domain.match(/local/)) {
                    return EnvUtil.ENV_LOCAL;
                }
                if (domain.match(/test2/)) {
                    return EnvUtil.ENV_TEST_2;
                }
                if (domain.match(/test/)) {
                    return EnvUtil.ENV_TEST;
                }
                if (domain.match(/stg/)) {
                    return EnvUtil.ENV_STG;
                }
                if (domain.match(/storybook/)) {
                    return EnvUtil.ENV_STORYBOOK;
                }
                return EnvUtil.ENV_PROD;
            }
        }
        return undefined;
    }
    static getNodeEnv() {
        if (EnvUtil.isNode) {
            return toLower(process.env.NODE_ENV);
        }
        return undefined;
    }
    /**
     * Main method to check on the current env.
     * May be extended to check on the currency NODE JS env.
     * @returns {*}
     */
    static getEnv() {
        return EnvUtil.getAppEnv() || EnvUtil.getNodeEnv();
    }
    static get isProd() {
        return EnvUtil.ENV_PROD === EnvUtil.getEnv();
    }
    static get isStg() {
        return EnvUtil.ENV_STG === EnvUtil.getEnv();
    }
    static get isTest() {
        return EnvUtil.ENV_TEST === EnvUtil.getEnv();
    }
    static get isTest2() {
        return EnvUtil.ENV_TEST_2 === EnvUtil.getEnv();
    }
    static get isLocal() {
        return EnvUtil.ENV_LOCAL === EnvUtil.getEnv();
    }
    static get isCI() {
        return !!process.env.CI;
    }
}
EnvUtil.ENV_LOCAL = 'local';
EnvUtil.ENV_TEST = 'test';
EnvUtil.ENV_TEST_2 = 'test2';
EnvUtil.ENV_STG = 'staging';
EnvUtil.ENV_PROD = 'production';
EnvUtil.ENV_STORYBOOK = 'storybook';
export default EnvUtil;
